import Vue from 'vue';
import orderTransformer from './../../transformers/order';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentOrder', orderTransformer.fetch(data));
  resolve(data);
};

const failed = (errors, reject) => {
  reject(orderTransformer.fetch(errors));
};

export default order => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/orders', orderTransformer.send(order))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/store.js